{
  "SLA": {
    "HEADER": "服務等級協議",
    "ADD_ACTION": "新增 SLA",
    "ADD_ACTION_LONG": "建立新的 SLA 政策",
    "DESCRIPTION": "服務等級協議（SLA）是定義您的團隊與客戶之間明確期望的合約。它建立了回應與解決時間的標準，形成一個責任歸屬的框架，確保提供一致且高品質的服務體驗。",
    "LEARN_MORE": "進一步瞭解 SLA",
    "COUNT": "{n} 個 SLA | {n} 個 SLA",
    "LOADING": "正在載入 SLA",
    "SEARCH_PLACEHOLDER": "搜尋 SLA...",
    "SEARCH": {
      "NO_RESULTS": "找不到符合搜尋條件的 SLA"
    },
    "PAYWALL": {
      "TITLE": "升級以建立 SLA",
      "AVAILABLE_ON": "SLA 功能僅在 Business 和 Enterprise 方案中提供。",
      "UPGRADE_PROMPT": "升級您的方案以使用進階功能，如團隊管理、自動化、自訂屬性等。",
      "UPGRADE_NOW": "立即升級",
      "CANCEL_ANYTIME": "您可以隨時變更或取消方案"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "SLA 功能僅在付費方案中提供。",
      "UPGRADE_PROMPT": "升級至付費方案以使用進階功能，如稽核紀錄、客服人員容量等。",
      "ASK_ADMIN": "請聯繫您的管理員進行升級。"
    },
    "LIST": {
      "404": "此帳戶中沒有可用的 SLA。",
      "TABLE_HEADER": {
        "SLA": "SLA",
        "BUSINESS_HOURS": "服務時間"
      },
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "企業客戶提出的問題，需要立即處理。",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "企業客戶提出的問題，需要盡快回覆確認。"
      },
      "BUSINESS_HOURS_ON": "已開啟",
      "BUSINESS_HOURS_OFF": "已關閉",
      "RESPONSE_TYPES": {
        "FRT": "首次回應時間門檻",
        "NRT": "後續回應時間門檻",
        "RT": "解決時間門檻",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "SLA 名稱",
        "PLACEHOLDER": "SLA 名稱",
        "REQUIRED_ERROR": "SLA 名稱為必填",
        "MINIMUM_LENGTH_ERROR": "最少需要 2 個字元",
        "VALID_ERROR": "僅允許使用英文字母、數字、連字號和底線"
      },
      "DESCRIPTION": {
        "LABEL": "描述",
        "PLACEHOLDER": "適用於進階客戶的 SLA"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "首次回應時間",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "後續回應時間",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "解決時間",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "服務時間",
        "PLACEHOLDER": "僅在服務時間內"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "門檻值必須為大於零的數字"
      },
      "EDIT": "編輯",
      "CREATE": "建立",
      "DELETE": "刪除",
      "CANCEL": "取消"
    },
    "ADD": {
      "TITLE": "新增 SLA",
      "DESC": "為優質服務訂下承諾！",
      "API": {
        "SUCCESS_MESSAGE": "SLA 新增成功",
        "ERROR_MESSAGE": "發生錯誤，請重試"
      }
    },
    "DELETE": {
      "TITLE": "刪除 SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA 刪除成功",
        "ERROR_MESSAGE": "發生錯誤，請重試"
      },
      "CONFIRM": {
        "TITLE": "確認刪除",
        "MESSAGE": "您確定要刪除 ",
        "YES": "是，刪除 ",
        "NO": "否，保留 "
      }
    },
    "EVENTS": {
      "TITLE": "SLA 未達標",
      "FRT": "首次回應時間",
      "NRT": "後續回應時間",
      "RT": "解決時間",
      "SHOW_MORE": "還有 {count} 筆",
      "HIDE": "隱藏 {count} 列"
    }
  }
}
